export default __webpack_public_path__ + "static/media/Vector2.a5b18e52.png";